var map = {
	"./accordionIndicator.svg": 47958,
	"./auditIcon.svg": 22083,
	"./auditIconActive.svg": 80489,
	"./bpunk.png": 79317,
	"./bpunk.svg": 86203,
	"./bridgeIcon.svg": 39035,
	"./bridgeIconActive.svg": 34289,
	"./bunnyicon2.svg": 86884,
	"./bunnylogo.svg": 84144,
	"./carrot.svg": 95262,
	"./carrotActive.svg": 60740,
	"./earnIcon.svg": 55986,
	"./earnIconActive.svg": 63808,
	"./explorerIcon.svg": 1221,
	"./explorerIconActive.svg": 99619,
	"./governanceIcon.svg": 45508,
	"./governanceIconActive.svg": 56482,
	"./home copy.svg": 60469,
	"./home.svg": 92346,
	"./homeActive copy.svg": 48799,
	"./homeActive.svg": 49848,
	"./migrationIcon.svg": 64038,
	"./migrationIconActive.svg": 43452,
	"./moonactive.svg": 88982,
	"./moonactiveActive.svg": 66572,
	"./moreIcon.svg": 23755,
	"./moreIconActive.svg": 99169,
	"./newsIcon.svg": 22593,
	"./newsIconActive.svg": 22951,
	"./nftIcon.svg": 43166,
	"./nftIconActive.svg": 82468,
	"./projectsIcon.svg": 66658,
	"./projectsIconActive.svg": 17680,
	"./rocketIcon.svg": 44880,
	"./smallbp copy.svg": 28405,
	"./smallbp.svg": 75162,
	"./smallbpActive.svg": 29944,
	"./smallbpactive copy.svg": 85951,
	"./swapIcon.svg": 32793,
	"./swapIconActive.svg": 53839,
	"./toolsLogo.svg": 36657,
	"./toolsLogoActive.svg": 26180,
	"./yieldsIcon.svg": 48434,
	"./yieldsIconActive.svg": 79232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74879;